import { createContext } from "react";

export const LoginContext = createContext<{
  isLoginModalOpen: boolean;
  setLoginModalOpen: (val: boolean) => void;
}>({
  isLoginModalOpen: false,
  setLoginModalOpen: () => {},
});
